<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(1)">
    <span>{{ 'menus.properties' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(2)">
    <span>{{ 'menus.add' | translate }} {{ 'menus.plugin' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(5)">
    <span>{{ 'menus.order' | translate }} {{ 'menus.plugins' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-normal" (click)="selectMenu(3)">
    <span>{{ 'menus.remove' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(4)">
    <span>{{ 'menus.show-hide-help' | translate }}</span>
  </div>
  <div
    *ngIf="currentPerson?.isHost && isConnection"
    class="ir-btn ir-btn--big th-btn-menulevel"
    (click)="selectMenu(7)"
  >
    <span>{{ 'menus.edit-json' | translate }}</span>
  </div>
</div>
